export default __webpack_public_path__ + "50fe1214ca7f290f8b9f48c03720658e.png";